import { useLingui } from "@lingui/react";
import FieldValuePair from "../../FieldValuePair.tsx";
import type { SpecProps } from "../types.ts";

export const InteriorColor = ({ interiorColor }: SpecProps<"interior_color">) => {
  const { i18n } = useLingui();

  if (interiorColor == null || interiorColor === "") {
    return null;
  }

  const field = i18n.t({
    id: "itemPageLayout.keyInfo.interior_color",
    message: "Interior color",
    comment: "Field for 'interior color' in ad specification",
  });
  return <FieldValuePair field={field} value={interiorColor} />;
};
